module.exports = __webpack_public_path__ + "img/Icon-blom_square.e4d9c080.png";